import { action } from 'typesafe-actions';
import { FormApi } from 'final-form';

import { ISmevMonitoringIndex } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringIndex';
import { ISmevMonitoringFilterIndex } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringFilterIndex';
import { ISmevMonitoringChart } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringChart';

import { SmevMonitoringActionsEnum } from '../enums/SmevMonitoringActionsEnum';
import { ISmevMonitoringFilter } from '../interfaces/ISmevMonitoringFilter';
import { SmevMonitoringColumnTypeEnum } from '../enums/SmevMonitoringColumnType';

export const smevMonitoringInitPage = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_INIT_PAGE);
export const smevMonitoringSetOrder = (order: string | null) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_ORDER, { order });
export const smevMonitoringGetTableData = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_TABLE_DATA);
export const smevMonitoringGetTableDataNextPage = () =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_TABLE_DATA_NEXT_PAGE);
export const smevMonitoringSetTableData = (
  tableData: ISmevMonitoringIndex[],
  page: number,
  pageCount: number,
  totalCount: number,
) => action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_TABLE_DATA, { tableData, page, pageCount, totalCount });
export const smevMonitoringGetSystemTypes = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_SYSTEM_TYPES);
export const smevMonitoringGetMessageTypes = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_MESSAGE_TYPES);
export const smevMonitoringGetSmevMessageTypes = () =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_SMEV_MESSAGE_TYPES);
export const smevMonitoringGetServiceTypes = (systemType: string) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_SERVICE_TYPES, { systemType });
export const smevMonitoringGetEndpoints = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_ENDPOINTS);
export const smevMonitoringGetProcessingStatuses = () =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_PROCESSING_STATUSES);
export const smevMonitoringGetSendingStatuses = () =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_SENDING_STATUSES);
export const smevMonitoringSetProcessingStatuses = (statuses: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_PROCESSING_STATUSES, { statuses });
export const smevMonitoringSetSendingStatuses = (statuses: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_SENDING_STATUSES, { statuses });
export const smevMonitoringSetSystemTypes = (systemTypes: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_SYSTEM_TYPES, { systemTypes });
export const smevMonitoringGetSystemCharts = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_SYSTEM_CHARTS);
export const smevMonitoringSetMessageTypes = (messageTypes: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_MESSAGE_TYPES, { messageTypes });
export const smevMonitoringSetSmevMessageTypes = (smevMessageTypes: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_SMEV_MESSAGE_TYPES, { smevMessageTypes });
export const smevMonitoringSetServiceTypes = (systemType: string, serviceType: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_SERVICE_TYPES, { systemType, serviceType });
export const smevMonitoringSetFilter = (filter: ISmevMonitoringFilterIndex | null) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_FILTER, { filter });
export const smevMonitoringSetEndpoints = (endpoints: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_ENDPOINTS, { endpoints });
export const smevMonitoringGetCharts = (
  systemType?: string,
  serviceType?: string,
  endpoint?: string,
  isAdditional?: boolean,
) => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_CHARTS, { systemType, serviceType, endpoint, isAdditional });
export const smevMonitoringSetCharts = (
  charts: ISmevMonitoringChart[],
  isLoading: boolean,
  systemType?: string,
  serviceType?: string,
  endpoint?: string,
  isAdditional?: boolean,
) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_CHARTS, {
    charts,
    isLoading,
    systemType,
    serviceType,
    endpoint,
    isAdditional,
  });
export const smevMonitoringSetAdditionalCharts = (
  charts: ISmevMonitoringChart[],
  isLoading: boolean,
  systemType?: string,
  serviceType?: string,
  endpoint?: string,
  isAdditional?: boolean,
) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_ADDITIONAL_CHARTS, {
    charts,
    isLoading,
    systemType,
    serviceType,
    endpoint,
    isAdditional,
  });
export const smevMonitoringResetAdditionalCharts = () =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_RESET_ADDITIONAL_CHARTS);
export const smevMonitoringSetFilterForm = (form: FormApi<ISmevMonitoringFilter, Partial<ISmevMonitoringFilter>>) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_FILTER_FORM, { form });
export const smevMonitoringGetMessageById = (id: number) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_MESSAGE_BY_ID, { id });
export const smevMonitoringSetMessageById = (messageById?: ISmevMonitoringIndex) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_MESSAGE_BY_ID, { messageById });
export const smevMonitoringDownloadMessage = (id: number, column: SmevMonitoringColumnTypeEnum) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_DOWNLOAD_MESSAGE, { id, column });
export const smevMonitoringGetChartsWithEndpoints = (systemType?: string, serviceType?: string) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_CHARTS_WITH_ENDPOINTS, { systemType, serviceType });
export const smevMonitoringSetLoadingAdditionalCharts = (value: boolean) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_LOADING_ADDITIONAL_CHARTS, { value });
export const smevMonitoringGetSenders = () => action(SmevMonitoringActionsEnum.SMEV_MONITORING_GET_SENDERS);
export const smevMonitoringSetSenders = (senders: string[]) =>
  action(SmevMonitoringActionsEnum.SMEV_MONITORING_SET_SENDERS, { senders });
